import React from "react";
import ProjectCard from "../components/projectCard";

function RecentProjects() {
  return (
    <section className="section-project" id="work">
      <h4 className="heading-secondary heading-secondary--color u-margin-top-big">
        My Portfolio
      </h4>
      <h4 className="heading-primary heading-primary--sub">Recent Works</h4>

      <div class="row">
        <ProjectCard
          image="card__picture--11"
          backColor="card__side--back-3"
          front={[
            "Tech Stack: ReactJs, Sass",
            "Official landing page of kyron.in, Its an online learning, skilling and assessments platform",
            "Responsive with modern design",
          ]}
          title="Kyron Landing Page"
          link="https://kyron.in/"
        />
        <ProjectCard
          image="card__picture--9"
          backColor="card__side--back-3"
          front={[
            "Tech Stack: Vuejs, Vuetify, Figma",
            "User can buy items directly from the landing page",
            "Responsive with modern design",
          ]}
          title="Kowi Landing Page"
          link="https://kowi.in/"
        />
        <ProjectCard
          image="card__picture--1"
          backColor="card__side--back-1"
          front={[
            "Tech Stack: VueJS, Vuetify.",
            "A single place for managing and tracking all the employees progress.",
            "Real time Attendance & Chat feature using otp and web-socket.",
          ]}
          title="Employee Management System"
          link="https://employee.kowi.in/"
        />
        <ProjectCard
          image="card__picture--3"
          backColor="card__side--back-3"
          front={[
            "Tech Stack: Flutter, Figma & Php",
            "A single app for Blogs and E-shop for solar products",
            "Simple UI with dark mode and hindi language support",
          ]}
          title="AnyaGreen Android App"
          link="https://play.google.com/store/apps/details?id=com.anyaenergy.anyaenergy"
        />
        <ProjectCard
          image="card__picture--2"
          backColor="card__side--back-2"
          front={[
            "Tech Stack: VueJS, Vuetify.",
            "Admin panel for anyagreen mobile app.",
            "Owner can add, edit, delete products, categories, blogs dynamically.",
          ]}
          title="AnyaGreen Admin Panel"
          link="https://anyagreenenergy.in/"
        />

        <ProjectCard
          image="card__picture--4"
          backColor="card__side--back-2"
          front={[
            "Tech Stack: VueJS, Vuetify.",
            "Teachomatrix is my own startup (LMS).",
            "Tons of features like Classroom, Quizzes, Realtime attendance, Meet Schedule, etc.",
          ]}
          title="Teachomatrix - LMS"
          link="https://student.teachomatrix.com/"
        />
        <ProjectCard
          image="card__picture--5"
          backColor="card__side--back-3"
          front={[
            "Tech Stack: VueJS, Vuetify.",
            "OSI helps you to track your all open-source Internships and Program in a single place.",
            "Theme switch option is available.",
          ]}
          title="Open Source Internship "
          link="https://rohan220217.github.io/open-source-internships/"
        />
        <ProjectCard
          image="card__picture--6"
          backColor="card__side--back-1"
          front={[
            "Tech Stack: VueJS, Bootstrap.",
            "Florist website for selling flowers and bouquets.",
            "Admin panel is also there to make changes.",
          ]}
          title="Ornate"
          link="http://shop.ornate.tk/"
        />
        <ProjectCard
          image="card__picture--7"
          backColor="card__side--back-1"
          front={[
            "Tech Stack: VueJS, Vuetify.",
            "Super user panel to update student fees and admin rights.",
            "Automatic deduction from credit card",
          ]}
          title="access2successonline"
          link="http://parent.access2successonline.com/"
        />
        <ProjectCard
          image="card__picture--8"
          backColor="card__side--back-2"
          front={[
            "Tech Stack: Html, Css, Bootstrap, JS",
            "Designed the entire frontend.",
          ]}
          title="VenaIndia"
          link="https://www.venaindia.com/"
        />

        <ProjectCard
          image="card__picture--10"
          backColor="card__side--back-2"
          front={[
            "Tech Stack: Html, Css, Bootstrap, JS.",
            "Created the official website of HackJNU and HackJNU 2.0.",
          ]}
          title="HackJNU"
          link="https://github.com/rohan220217/hackjnu2.0"
        />
      </div>
    </section>
  );
}

export default RecentProjects;
